<template>
    <span class="field-label-inline">
        <b-icon v-if="field.icon" :icon="field.icon" size="is-small" />
        <span
            >{{ field.label }}<span v-if="editing && field.required" class="field-required" aria-hidden="true"></span
        ></span>
        <help-tooltip v-if="field.help" :label="field.help" class="ml-1" />
    </span>
</template>

<script setup>
/**
 * A field's name, with the marks that qualify it: its icon, the asterisk of a
 * required field, its help.
 *
 * A required field is marked with a dot rather than an asterisk: the same shape
 * the legend at the foot of the fiche uses for every other mark it names, so a
 * reader learns one vocabulary instead of two. An element of its own, so it can
 * carry its own colour — written into the label's text it took the label's, and
 * the label is deliberately the quiet part of the row.
 *
 * `aria-hidden`, because "required" is not a colour: the input itself carries
 * the `required` attribute, which is what a screen reader announces.
 */
defineProps({
    field: { type: Object, required: true },
    editing: { type: Boolean, default: false }
});
</script>

<style scoped>
.field-label-inline {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
}

/* Red, and never inherited from the label around it: this is the mark the
   legend at the foot of the fiche names, and the two have to match. */
.field-required {
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: var(--bulma-danger);
    margin-left: 0.3em;
    vertical-align: 0.15em;
}
</style>
